import axios, { AxiosError } from "axios";
import AuthClient from "./AuthClient";
import { offerRequestModel } from "../api/models/CreateOfferModel";
import joinTableOfferRequest from "./models/CreateJoinTableOfferModel";
import { handleAxiosError } from "./responses/AxiosResponseHandler";

class CreateJoinTableOfferApi {
    private authClient: AuthClient;

    constructor(authClient: AuthClient) {
        this.authClient = authClient;
    }

    public async createJoinTableOffer(offerRequest: joinTableOfferRequest) {

        try {
            const authenticationResponse = this.authClient.getAuthenticationResponse();
            const response = await axios.post(
                `${this.authClient.getApiRoot()}/offers/CreateJoinTableOffer`,
                offerRequest,
                {
                    headers: {
                        Authorization: `Bearer ${authenticationResponse?.token}`,
                    },
                }
            );
            return {
                statusCode: response.status,
                badRequestMessage: response.data
            };

        } catch (error) {
            const errorResponse = handleAxiosError(error as AxiosError);
            return {
                statusCode: errorResponse.statusCode,
                errorMessage: errorResponse.errorMessage,
                data: errorResponse.data
            }
        }
    }
}

export default CreateJoinTableOfferApi;
